"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var account_1 = require("../../account");
var jsHelpers_1 = require("../../bridge/jsHelpers");
var api_1 = require("./api");
var logic_1 = require("./logic");
function buildElrondESDTTokenAccount(_a) {
    var parentAccountId = _a.parentAccountId, accountAddress = _a.accountAddress, token = _a.token, balance = _a.balance;
    return __awaiter(this, void 0, void 0, function () {
        var tokenAccountId, tokenIdentifierHex, tokenIdentifier, operations, tokenAccount;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    tokenAccountId = (0, account_1.encodeTokenAccountId)(parentAccountId, token);
                    tokenIdentifierHex = (0, logic_1.extractTokenId)(token.id);
                    tokenIdentifier = Buffer.from(tokenIdentifierHex, "hex").toString();
                    return [4 /*yield*/, (0, api_1.getESDTOperations)(tokenAccountId, accountAddress, tokenIdentifier, 0)];
                case 1:
                    operations = _b.sent();
                    tokenAccount = {
                        type: "TokenAccount",
                        id: tokenAccountId,
                        parentId: parentAccountId,
                        starred: false,
                        token: token,
                        operationsCount: operations.length,
                        operations: operations,
                        pendingOperations: [],
                        balance: balance,
                        spendableBalance: balance,
                        swapHistory: [],
                        creationDate: operations.length > 0
                            ? operations[operations.length - 1].date
                            : new Date(),
                        balanceHistoryCache: account_1.emptyHistoryCache
                    };
                    return [2 /*return*/, tokenAccount];
            }
        });
    });
}
function syncESDTTokenAccountOperations(tokenAccount, address) {
    return __awaiter(this, void 0, void 0, function () {
        var oldOperations, startAt, tokenIdentifierHex, tokenIdentifier, newOperations, operations, copy;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    oldOperations = (tokenAccount === null || tokenAccount === void 0 ? void 0 : tokenAccount.operations) || [];
                    startAt = oldOperations.length
                        ? Math.floor(oldOperations[0].date.valueOf() / 1000)
                        : 0;
                    tokenIdentifierHex = (0, logic_1.extractTokenId)(tokenAccount.token.id);
                    tokenIdentifier = Buffer.from(tokenIdentifierHex, "hex").toString();
                    return [4 /*yield*/, (0, api_1.getESDTOperations)(tokenAccount.id, address, tokenIdentifier, startAt)];
                case 1:
                    newOperations = _a.sent();
                    operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
                    if (operations === oldOperations)
                        return [2 /*return*/, tokenAccount];
                    copy = __assign({}, tokenAccount);
                    copy.operations = operations;
                    copy.operationsCount = operations.length;
                    return [2 /*return*/, copy];
            }
        });
    });
}
function elrondBuildESDTTokenAccounts(_a) {
    var currency = _a.currency, accountId = _a.accountId, accountAddress = _a.accountAddress, existingAccount = _a.existingAccount, syncConfig = _a.syncConfig;
    return __awaiter(this, void 0, void 0, function () {
        var _b, blacklistedTokenIds, tokenAccounts, existingAccountByTicker, existingAccountTickers, _c, _d, existingSubAccount, _e, ticker, id, accountESDTs, accountESDTs_1, accountESDTs_1_1, esdt, esdtIdentifierHex, token, tokenAccount, inputTokenAccount, balance, e_1_1;
        var e_2, _f, e_1, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _b = syncConfig.blacklistedTokenIds, blacklistedTokenIds = _b === void 0 ? [] : _b;
                    if ((0, cryptoassets_1.listTokensForCryptoCurrency)(currency).length === 0) {
                        return [2 /*return*/, undefined];
                    }
                    tokenAccounts = [];
                    existingAccountByTicker = {};
                    existingAccountTickers = [];
                    if (existingAccount && existingAccount.subAccounts) {
                        try {
                            for (_c = __values(existingAccount.subAccounts), _d = _c.next(); !_d.done; _d = _c.next()) {
                                existingSubAccount = _d.value;
                                if (existingSubAccount.type === "TokenAccount") {
                                    _e = existingSubAccount.token, ticker = _e.ticker, id = _e.id;
                                    if (!blacklistedTokenIds.includes(id)) {
                                        existingAccountTickers.push(ticker);
                                        existingAccountByTicker[ticker] = existingSubAccount;
                                    }
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_f = _c["return"])) _f.call(_c);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    return [4 /*yield*/, (0, api_1.getAccountESDTTokens)(accountAddress)];
                case 1:
                    accountESDTs = _h.sent();
                    _h.label = 2;
                case 2:
                    _h.trys.push([2, 10, 11, 12]);
                    accountESDTs_1 = __values(accountESDTs), accountESDTs_1_1 = accountESDTs_1.next();
                    _h.label = 3;
                case 3:
                    if (!!accountESDTs_1_1.done) return [3 /*break*/, 9];
                    esdt = accountESDTs_1_1.value;
                    esdtIdentifierHex = Buffer.from(esdt.identifier).toString("hex");
                    token = (0, cryptoassets_1.findTokenById)((0, logic_1.addPrefixToken)(esdtIdentifierHex));
                    if (!(token && !blacklistedTokenIds.includes(token.id))) return [3 /*break*/, 8];
                    tokenAccount = existingAccountByTicker[token.ticker];
                    if (!!tokenAccount) return [3 /*break*/, 5];
                    return [4 /*yield*/, buildElrondESDTTokenAccount({
                            parentAccountId: accountId,
                            accountAddress: accountAddress,
                            token: token,
                            balance: new bignumber_js_1["default"](esdt.balance)
                        })];
                case 4:
                    tokenAccount = _h.sent();
                    return [3 /*break*/, 7];
                case 5:
                    inputTokenAccount = tokenAccount;
                    return [4 /*yield*/, syncESDTTokenAccountOperations(inputTokenAccount, accountAddress)];
                case 6:
                    tokenAccount = _h.sent();
                    balance = new bignumber_js_1["default"](esdt.balance);
                    if (!balance.eq(tokenAccount.balance)) {
                        // only recreate the object if balance changed
                        if (inputTokenAccount === tokenAccount) {
                            tokenAccount = __assign({}, tokenAccount);
                        }
                        tokenAccount.balance = balance;
                        tokenAccount.spendableBalance = balance;
                    }
                    _h.label = 7;
                case 7:
                    if (tokenAccount) {
                        tokenAccounts.push(tokenAccount);
                        existingAccountTickers.push(token.ticker);
                        existingAccountByTicker[token.ticker] = tokenAccount;
                    }
                    _h.label = 8;
                case 8:
                    accountESDTs_1_1 = accountESDTs_1.next();
                    return [3 /*break*/, 3];
                case 9: return [3 /*break*/, 12];
                case 10:
                    e_1_1 = _h.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 12];
                case 11:
                    try {
                        if (accountESDTs_1_1 && !accountESDTs_1_1.done && (_g = accountESDTs_1["return"])) _g.call(accountESDTs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 12:
                    // Preserve order of tokenAccounts from the existing token accounts
                    tokenAccounts.sort(function (a, b) {
                        var i = existingAccountTickers.indexOf(a.token.ticker);
                        var j = existingAccountTickers.indexOf(b.token.ticker);
                        if (i === j)
                            return 0;
                        if (i < 0)
                            return 1;
                        if (j < 0)
                            return -1;
                        return i - j;
                    });
                    return [2 /*return*/, tokenAccounts];
            }
        });
    });
}
exports["default"] = elrondBuildESDTTokenAccounts;
//# sourceMappingURL=js-buildSubAccounts.js.map